import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["indeterminate", "checked"]

import { computed } from "vue";

type CheckboxState = "unchecked" | "indeterminate" | "checked";


export default /*#__PURE__*/_defineComponent({
  __name: 'FeedbackGroupCheckbox',
  props: {
    groupIds: {},
    selectedIds: {}
  },
  emits: ["checked", "unchecked"],
  setup(__props: any, { emit }) {

const props = __props;





const checkboxState = computed<CheckboxState>(() => {
  const selected = props.groupIds.filter((id) =>
    props.selectedIds.includes(id)
  );
  if (selected.length === props.groupIds.length) {
    return "checked";
  } else if (selected.length > 0) {
    return "indeterminate";
  } else {
    return "unchecked";
  }
});

const handleInput = (checked: boolean) => {
  if (checked) {
    emit("checked", props.groupIds);
  } else {
    emit("unchecked", props.groupIds);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", {
    type: "checkbox",
    indeterminate: checkboxState.value === 'indeterminate',
    checked: checkboxState.value === 'checked',
    onInput: _cache[0] || (_cache[0] = ($event: any) => (handleInput($event.target.checked)))
  }, null, 40, _hoisted_1))
}
}

})